import { Box, Heading, Link, Text, VStack } from '@chakra-ui/react';

export const EnrollmentSuccessInfo = (props: any) => {
	return (
		<Box>
			<VStack m={100}>
				<Heading size="lg" pb={10}>
					Dziękujemy! Rezerwacja wysłana pomyślnie.
				</Heading>
				<Text pb={16}>
					Gdy tylko zostanie przez nas zweryfikowana otrzymasz od nas wiadomość na podany przez ciebie adres e-mail.
				</Text>
				<Link fontSize="sm" href="/" color="orange">
					Powrót na stronę główną
				</Link>
			</VStack>
		</Box>
	);
};
